// import { useEffect, useState } from "react";
// import { useMap } from "react-leaflet";
// import L from "leaflet";
// import { selectLayerDataSet } from "../../../features/layers/overlaylayerslice";
// import { useSelector } from "react-redux";

// const GeopotentialLayer = () => {
//   const map = useMap();
//   const overlayLayers = useSelector(selectLayerDataSet);
//   const [mainData, setMainData] = useState(null);
//   const [geopotentialLayer, setGeopotentialLayer] = useState(null); // State to store the geopotential layer instance

//   useEffect(() => {
//     const datas = (data) => {
//       if (data.text==='Global Model' && data.class === 'Model') {
//         setMainData(data);
//         console.log(data);
//       }
//     };
//     if (Array.isArray(overlayLayers)) {
//       overlayLayers.forEach((overlayer) => datas(overlayer));
//     }
//   }, [overlayLayers]);

//   useEffect(() => {
//     if (!map || !mainData) return;
//     if (geopotentialLayer) {
//       map.removeLayer(geopotentialLayer);
//       setGeopotentialLayer(null);
//     }

//     const center = map.getCenter();
//     const lat = center.lat;
//     const lng = center.lng;

//     console.log(mainData);
//     let url;
//     if (mainData.text === 'Global Model' && mainData.showGeopotentialHeights) {
//       url = `https://api.ncmrwf.gov.in/mslp/?data=NaN&date=${mainData.date}&pressure=${mainData.altitude}&hour=`;
//     }

//     fetch(url)
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error("Failed to fetch geopotential data");
//         }
//         return response.json();
//       })
//       .then((geoJsonData) => {
//         console.log("Geopotential data loaded", geoJsonData);

//         // Create a new GeoJSON layer
//         const newGeopotentialLayer = L.geoJSON(geoJsonData, {
//             style: (feature) => ({
//               color: "#94e2ed",  // Updated color
//               weight: 2,
//               opacity: 1,
//               fillColor: "#94e2ed",
//               fillOpacity: 0.5,
//             }),
//             onEachFeature: (feature, layer) => {
//                 if (feature.geometry && feature.geometry.type === "LineString") {
//                   // Add elevation in the middle of the line
//                   const latlngs = layer.getLatLngs();
//                   const middleIndex = Math.floor(latlngs.length / 2);
//                   const middleLatLng = latlngs[middleIndex];
    
//                   if (feature.properties && feature.properties.elevation) {
//                     const elevation = Math.round(feature.properties.elevation); // Round to integer
//                     const elevationText = `<b></b> ${elevation}`; // Display as integer
    
//                     // Create a div icon to show elevation as text
//                     const elevationLabel = L.divIcon({
//                       className: 'elevation-label',
//                       html: elevationText,
//                       iconSize: [60, 20], // Reduced size
//                       iconAnchor: [30, 10], // Adjust anchor to center the text
//                     });
    
//                     // Add the label at the middle of the line
//                     L.marker(middleLatLng, { icon: elevationLabel }).addTo(map);
//                   }
//                 }
//               },
//             });
  
//           newGeopotentialLayer.addTo(map);
//           setGeopotentialLayer(newGeopotentialLayer);
//       })
//       .catch((error) => {
//         console.error("Error loading geopotential data:", error);
//       });
//   }, [map, mainData]);

//   return null;
// };

// export default GeopotentialLayer;


// import { useEffect, useState } from "react";
// import { useMap } from "react-leaflet";
// import L from "leaflet";
// import { selectLayerDataSet } from "../../../features/layers/overlaylayerslice";
// import { useSelector } from "react-redux";

// const GeopotentialLayer = () => {
//   const map = useMap();
//   const overlayLayers = useSelector(selectLayerDataSet);
//   const [mainData, setMainData] = useState(null);
//   const [geopotentialLayer, setGeopotentialLayer] = useState(null);
//   const [labelMarkers, setLabelMarkers] = useState([]); // State to store elevation labels

//   useEffect(() => {
//     const selectedData = overlayLayers.find(
//       (data) => data.text === "Global Model" && data.class === "Model"
//     );
//     setMainData(selectedData || null);
//   }, [overlayLayers]);

//   useEffect(() => {
//     if (!map || !mainData) return;

//     if (!mainData.showGeopotentialHeights) {
//       if (geopotentialLayer) {
//         map.removeLayer(geopotentialLayer);
//         setGeopotentialLayer(null);
//       }
//       // Remove all label markers
//       labelMarkers.forEach((marker) => map.removeLayer(marker));
//       setLabelMarkers([]);
//       return;
//     }

//     if (geopotentialLayer) return; // Prevent duplicate layers

//     const center = map.getCenter();
//     const lat = center.lat;
//     const lng = center.lng;

//     const url = `https://api.ncmrwf.gov.in/mslp/?data=NaN&date=${mainData.date}&pressure=${mainData.altitude}&hour=`;

//     fetch(url)
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error("Failed to fetch geopotential data");
//         }
//         return response.json();
//       })
//       .then((geoJsonData) => {
//         console.log("Geopotential data loaded", geoJsonData);

//         const newLabelMarkers = [];
        
//         const newGeopotentialLayer = L.geoJSON(geoJsonData, {
//           style: () => ({
//             color: "#94e2ed",
//             weight: 2,
//             opacity: 1,
//             fillColor: "#94e2ed",
//             fillOpacity: 0.5,
//           }),
//           onEachFeature: (feature, layer) => {
//             if (feature.geometry && feature.geometry.type === "LineString") {
//               const latlngs = layer.getLatLngs();
//               const middleIndex = Math.floor(latlngs.length / 2);
//               const middleLatLng = latlngs[middleIndex];

//               if (feature.properties && feature.properties.elevation) {
//                 const elevation = Math.round(feature.properties.elevation);
//                 const elevationText = `<b>${elevation}</b>`;

//                 const elevationLabel = L.divIcon({
//                   className: 'elevation-label',
//                   html: elevationText,
//                   iconSize: [60, 20],
//                   iconAnchor: [30, 10],
//                 });

//                 const marker = L.marker(middleLatLng, { icon: elevationLabel }).addTo(map);
//                 newLabelMarkers.push(marker);
//               }
//             }
//           },
//         });

//         newGeopotentialLayer.addTo(map);
//         setGeopotentialLayer(newGeopotentialLayer);
//         setLabelMarkers(newLabelMarkers);
//       })
//       .catch((error) => {
//         console.error("Error loading geopotential data:", error);
//       });
//   }, [map, mainData, geopotentialLayer]);

//   return null;
// };

// export default GeopotentialLayer;


// import { useEffect, useState } from "react";
// import { useMap } from "react-leaflet";
// import L from "leaflet";
// import { selectLayerDataSet } from "../../../features/layers/overlaylayerslice";
// import { useSelector } from "react-redux";

// const GeopotentialLayer = () => {
//   const map = useMap();
//   const overlayLayers = useSelector(selectLayerDataSet);
//   const [mainData, setMainData] = useState(null);
//   const [geopotentialLayer, setGeopotentialLayer] = useState(null);
//   const [labelMarkers, setLabelMarkers] = useState([]);

//   useEffect(() => {
//     const selectedData = overlayLayers.find(
//       (data) => data.text === "Global Model" && data.class === "Model"
//     );
//     setMainData(selectedData || null);
//   }, [overlayLayers]);

//   useEffect(() => {
//     if (!map || !mainData || !mainData.showGeopotentialHeights) {
//       if (geopotentialLayer) {
//         map.removeLayer(geopotentialLayer);
//         setGeopotentialLayer(null);
//       }
//       labelMarkers.forEach((marker) => map.removeLayer(marker));
//       setLabelMarkers([]);
//       return;
//     }

//     if (geopotentialLayer) {
//       map.removeLayer(geopotentialLayer);
//       setGeopotentialLayer(null);
//     }
//     labelMarkers.forEach((marker) => map.removeLayer(marker));
//     setLabelMarkers([]);

//     const center = map.getCenter();
//     const lat = center.lat;
//     const lng = center.lng;

//     const url = `https://api.ncmrwf.gov.in/mslp/?data=NaN&date=${mainData.date}&pressure=${mainData.altitude}&hour=`;

//     fetch(url)
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error("Failed to fetch geopotential data");
//         }
//         return response.json();
//       })
//       .then((geoJsonData) => {
//         console.log("Geopotential data loaded", geoJsonData);

//         const newLabelMarkers = [];
//         const newGeopotentialLayer = L.geoJSON(geoJsonData, {
//           style: () => ({
//             color: "#94e2ed",
//             weight: 2,
//             opacity: 1,
//             fillColor: "#94e2ed",
//             fillOpacity: 0.5,
//           }),
//           onEachFeature: (feature, layer) => {
//             if (feature.geometry && feature.geometry.type === "LineString") {
//               const latlngs = layer.getLatLngs();
//               const middleIndex = Math.floor(latlngs.length / 2);
//               const middleLatLng = latlngs[middleIndex];

//               if (feature.properties && feature.properties.elevation) {
//                 const elevation = Math.round(feature.properties.elevation);
//                 const elevationText = `<b>${elevation}</b>`;

//                 const elevationLabel = L.divIcon({
//                   className: 'elevation-label',
//                   html: elevationText,
//                   iconSize: [60, 20],
//                   iconAnchor: [30, 10],
//                 });

//                 const marker = L.marker(middleLatLng, { icon: elevationLabel }).addTo(map);
//                 newLabelMarkers.push(marker);
//               }
//             }
//           },
//         });

//         newGeopotentialLayer.addTo(map);
//         setGeopotentialLayer(newGeopotentialLayer);
//         setLabelMarkers(newLabelMarkers);
//       })
//       .catch((error) => {
//         console.error("Error loading geopotential data:", error);
//       });
//   }, [map, mainData?.date, mainData?.altitude, mainData?.showGeopotentialHeights]);

//   return null;
// };

// export default GeopotentialLayer;


import { useEffect, useState } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import { selectLayerDataSet } from "../../../features/layers/overlaylayerslice";
import { useSelector } from "react-redux";

const GeopotentialLayer = () => {
  const map = useMap();
  const overlayLayers = useSelector(selectLayerDataSet);
  const [mainData, setMainData] = useState(null);
  const [geopotentialLayer, setGeopotentialLayer] = useState(null);
  const [labelMarkers, setLabelMarkers] = useState([]);

  useEffect(() => {
    const selectedData = overlayLayers.find(
      (data) => data.text === "Mithuna GLB" && data.class === "Model"
    );
    setMainData(selectedData || null);
  }, [overlayLayers]);

  useEffect(() => {
    if (!map || !mainData || !mainData.showGeopotentialHeights) {
      // Clean up the current geopotential layer and label markers
      if (geopotentialLayer) {
        map.removeLayer(geopotentialLayer);
        setGeopotentialLayer(null);
      }
      labelMarkers.forEach((marker) => map.removeLayer(marker));
      setLabelMarkers([]);
      return;
    }

    // Clean up the previous geopotential layer and label markers
    if (geopotentialLayer) {
      map.removeLayer(geopotentialLayer);
      setGeopotentialLayer(null);
    }
    labelMarkers.forEach((marker) => map.removeLayer(marker));
    setLabelMarkers([]);

    const center = map.getCenter();
    const lat = center.lat;
    const lng = center.lng;

    const url = `https://api.ncmrwf.gov.in/mslp/?data=NaN&date=${mainData.date}&odate=${mainData.odate}&pressure=${mainData.altitude}&hour=`;

    // To prevent stale responses from updating the map
    let isCancelled = false;

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch geopotential data");
        }
        return response.json();
      })
      .then((geoJsonData) => {
        if (isCancelled) return; // If the component is unmounted or a new request is made, skip this result

        console.log("Geopotential data loaded", geoJsonData);

        const newLabelMarkers = [];
        const newGeopotentialLayer = L.geoJSON(geoJsonData, {
          style: () => ({
            color: "#94e2ed",
            weight: 2,
            opacity: 1,
            fillColor: "#94e2ed",
            fillOpacity: 0.5,
          }),
          onEachFeature: (feature, layer) => {
            if (feature.geometry && feature.geometry.type === "LineString") {
              const latlngs = layer.getLatLngs();
              const middleIndex = Math.floor(latlngs.length / 2);
              const middleLatLng = latlngs[middleIndex];

              if (feature.properties && feature.properties.elevation) {
                const elevation = Math.round(feature.properties.elevation);
                const elevationText = `<b>${elevation}</b>`;

                const elevationLabel = L.divIcon({
                  className: 'elevation-label',
                  html: elevationText,
                  iconSize: [60, 20],
                  iconAnchor: [30, 10],
                });

                const marker = L.marker(middleLatLng, { icon: elevationLabel }).addTo(map);
                newLabelMarkers.push(marker);
              }
            }
          },
        });

        newGeopotentialLayer.addTo(map);
        setGeopotentialLayer(newGeopotentialLayer);
        setLabelMarkers(newLabelMarkers);
      })
      .catch((error) => {
        console.error("Error loading geopotential data:", error);
      });

    // Cleanup function to set isCancelled to true when the effect is cleaned up or new data is loaded
    return () => {
      isCancelled = true;
      if (geopotentialLayer) {
        map.removeLayer(geopotentialLayer);
      }
      labelMarkers.forEach((marker) => map.removeLayer(marker));
    };
  }, [map, mainData?.date, mainData?.altitude, mainData?.showGeopotentialHeights]);

  return null;
};

export default GeopotentialLayer;
